import { useEffect } from 'react';

const AdminDashboard = () => {
  useEffect(() => {
    window.location.replace('/admin-dashboard.html');
  }, []);

  return null;
};

export default AdminDashboard;
